import { McpEnvLabel } from './mcpEnvLabel';

export interface ClaudeMcpAddArgs {
  env: McpEnvLabel;
  serverUrl: string;
  accessId: string;
  token: string;
}

export const buildClaudeMcpAddCommand = ({ env, serverUrl, accessId, token }: ClaudeMcpAddArgs): string => {
  const baseUrl = serverUrl.replace(/\/+$/, '');
  return (
    `claude mcp add --transport http upstack-mcp-${env} ` +
    `${baseUrl}/api/mcp/${accessId} ` +
    `--header "Authorization: Bearer ${token}" -s user`
  );
};
